/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TclItsmCorestackResourceMapping {
    getFixupPrototypeFunction() { return TclItsmCorestackResourceMapping.fixupPrototype; }

    static newInstance(model: Partial<TclItsmCorestackResourceMapping>): TclItsmCorestackResourceMapping {
        let obj = Object.assign(new TclItsmCorestackResourceMapping(), model);
        TclItsmCorestackResourceMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TclItsmCorestackResourceMapping>): TclItsmCorestackResourceMapping {
        if (!model) return null;
        return TclItsmCorestackResourceMapping.newInstance(<TclItsmCorestackResourceMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TclItsmCorestackResourceMapping) {
        if (!obj) return;

        models.TclItsmCorestackResourceMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TclItsmCorestackResourceMapping): boolean {
        Object.setPrototypeOf(obj, TclItsmCorestackResourceMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attribute_mapping) {
            for (let val of this.attribute_mapping) {
                models.TclCorestackAttributeMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * Cloud Provider to select
     */
    cloud_service: models.CloudServiceName;

    /**
     * Corestack resource category
     */
    resource_category: string;

    /**
     * Corestack resource type
     */
    resource_type: string;

    /**
     * Mapping of TCL and corestack attributes of resources
     */
    attribute_mapping: Array<models.TclCorestackAttributeMapping>;

}
